import { render } from "./view-quotation.vue?vue&type=template&id=210177ad&scoped=true"
import script from "./view-quotation.vue?vue&type=script&lang=js"
export * from "./view-quotation.vue?vue&type=script&lang=js"

import "./view-quotation.vue?vue&type=style&index=0&id=210177ad&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210177ad"]])

export default __exports__